import { render } from "./LawyersList.vue?vue&type=template&id=aad68108"
import script from "./LawyersList.vue?vue&type=script&lang=js"
export * from "./LawyersList.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__